export const CONSTANTS = {
    resultPageResetButtonText: 'Restart form',
    resultPageGeneratePdfButtonText: 'Download PDF',
}